import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="schema-drawer-hidden-row"
export default class extends Controller {
  static targets = ["field", "checkbox"]

  toggle() {
    if (this.hasFieldTarget && this.checkboxTarget.checked) {
      this.fieldTargets.forEach(field => {
        field.classList.remove("hidden")
      })
    } else {
      this.fieldTargets.forEach(field => {
        field.classList.add("hidden")
      })
    }
  }
}
